// extracted by mini-css-extract-plugin
module.exports = {"menuWrapper":"fixture-menu-module--menuWrapper--1UFaE"};